import { cn, RangeButtons } from "@quortex/front-common"
import type { ChartCardProps } from "@/components/ChartCard"
import { DashboardCard } from "@/components/DashboardCard"

const ChartCard = ({ title, additionalControls, className, children }: ChartCardProps) => {
  return (
    <DashboardCard className={cn("overflow-x-hidden", className)}>
      <div className={cn("grid gap-y-md", additionalControls ? "grid-cols-3" : "grid-cols-2")}>
        <div
          className={cn(
            "font-medium text-sm",
            additionalControls ? "mobile:col-span-3" : "mobile:col-span-2"
          )}
        >
          {title}
        </div>
        {additionalControls && (
          <div className="mobile:col-span-3 justify-self-center">{additionalControls}</div>
        )}
        <RangeButtons
          className={cn(
            "desktop:col-span-1 justify-self-end",
            additionalControls ? "col-span-3" : "mobile:col-span-2"
          )}
        />
      </div>
      <div className="mt-md">{children}</div>
    </DashboardCard>
  )
}

export default ChartCard
